import { CONFIGURATION_TYPES } from "shared/types/enums";

export const CONFIGURATIONS = [
    CONFIGURATION_TYPES.MainConfiguration,
    CONFIGURATION_TYPES.OneWireAuthorizationList,
    CONFIGURATION_TYPES.BluetoothAuthorizationList,
    CONFIGURATION_TYPES.ManualGeofenceList
];
